import React from 'react';

import { ExternalEmrLetterMark } from './ExternalEmrLetterMark';
import { IMPORTED_FROM_EXTERNAL_EMR_TOOLTIP } from './externalCustody';

export interface ManagedInExternalEmrMarkProps {
  imported: boolean | null | undefined;
}

/**
 * The [E] mark on a task imported from the External EMR (EMR-3239). A sibling
 * of `ExternalCustodyBadge`, which says who bills. Renders nothing unless
 * `imported` is true. A tap opens the tooltip, as there.
 */
export const ManagedInExternalEmrMark: React.FC<
  ManagedInExternalEmrMarkProps
> = ({ imported }) => {
  if (imported !== true) return null;

  return (
    <ExternalEmrLetterMark
      tooltip={IMPORTED_FROM_EXTERNAL_EMR_TOOLTIP}
      testId='managed-in-external-emr-mark'
    />
  );
};

export default ManagedInExternalEmrMark;
